export default __webpack_public_path__ + "static/media/marker.440f77be.png";